export function hasSpeechEnergy(samples: Float32Array) {
  if (!samples.length) return false;
  let sum = 0;
  for (const value of samples) sum += value * value;
  return Math.sqrt(sum / samples.length) > 0.001;
}

export class LocalSpeech {
  private worker: Worker | null = null;
  dispose() { this.worker?.terminate(); this.worker = null; }
  async transcribe(audio: {samples: Float32Array; sampleRate: number}, signal: AbortSignal, progress: (message: string) => void): Promise<string> {
    progress("Ses kaydı hazırlanıyor…");
    if (signal.aborted) throw new Error("İşlem iptal edildi.");
    const duration = audio.samples.length / audio.sampleRate;
    if (!Number.isFinite(duration) || duration <= 0 || duration > 47) throw new Error("Kayıt boş veya çok uzun. En fazla 45 saniye konuşun.");
    const offline = new OfflineAudioContext(1, Math.ceil(duration * 16000), 16000);
    const buffer = offline.createBuffer(1, audio.samples.length, audio.sampleRate);
    buffer.copyToChannel(new Float32Array(audio.samples), 0);
    const source = offline.createBufferSource();
    source.buffer = buffer; source.connect(offline.destination); source.start();
    const samples = (await offline.startRendering()).getChannelData(0);
    if (signal.aborted) throw new Error("İşlem iptal edildi.");
    if (!hasSpeechEnergy(samples)) throw new Error("Ses duyulamadı. Mikrofona yaklaşarak tekrar deneyin.");
    this.worker ??= new Worker(new URL("./local-speech.worker.ts", import.meta.url), { type: "module" });
    const worker = this.worker;
    return new Promise((resolve, reject) => {
      const cleanup = () => { clearTimeout(timeout); signal.removeEventListener("abort", abort); worker.onmessage = null; worker.onerror = null; };
      const fail = (message: string) => { cleanup(); this.dispose(); reject(new Error(message)); };
      const abort = () => fail("İşlem iptal edildi.");
      const timeout = setTimeout(() => fail("Cihaz ses kaydını zamanında işleyemedi. Daha kısa kayıt deneyin veya notu yazın."), 300000);
      signal.addEventListener("abort", abort, { once: true });
      worker.onerror = () => fail("Ses motoru bu cihazda başlatılamadı. Notu yazarak kaydedebilirsiniz.");
      worker.onmessage = (event: MessageEvent<{status:string;message:string;text:string}>) => {
        if (event.data.status === "progress") progress(event.data.message);
        else if (event.data.status === "done") { cleanup(); resolve(event.data.text); }
        else if (event.data.status === "error") fail(event.data.message);
      };
      worker.postMessage({ audio: samples }, [samples.buffer]);
    });
  }
}
